import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams, useLocation} from "react-router-dom";
import {Card,Alert, Col,Button, Form, Row, Spin, Input, Select, Grid, Image, DatePicker} from "antd";
import {ButtonContainer} from "../../../MaterialsDetail/style";
import {LeftOutlined,CalendarOutlined, UserOutlined, ManOutlined, WomanOutlined} from "@ant-design/icons";
import {MyButton, MyText} from "../../../../components";
import {fetchAddChildAction, fetchChildrensAction, fetchUpdateChildAction, RootState, selectStore} from "../../../../utils";
import {useTranslation} from "react-i18next";
import { StyledAutoComplete, StyledSelect } from "../../../ScreeningEarly/testsList/style";
import { RightOutlined } from "@ant-design/icons";
import { fetchModules } from "../../../../utils";
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import localeRu from "antd/es/date-picker/locale/ru_RU";
import localeKz from "antd/es/date-picker/locale/kk_KZ";
import dayjs from "dayjs";
import { useLang } from "../../../../utils/context/lang";
export const SelectedScreeningTestIdPage = () => {
  const [childName, setChildName] = useState(""); 
  const [childId, setChildId] = useState(""); 

  const [age, setAge] = useState(null);

  const {testId} = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const { Option } = Select;
  
  const screens = useBreakpoint();
  const [answers, setAnswers] = useState<{ [key: number]: number }>({});
    const [editingChild, setEditingChild] = useState(null);
  const childrensList = useSelector((state: any) => state.materials.childrens);
  const childrens = childrensList.data?.children || [];
  const loading = childrensList.loading;
  // const [childrens, setChildrens] = useState([]);
   const [selectedId, setSelectedId] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
  const [hoveredButtonIndex, setHoveredButtonIndex] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const updateProfile = useSelector((state: any) => state.materials?.updateProfile ?? { loading: false });
  const addChild = useSelector((state: any) => state.materials?.addChild ?? { loading: false });
  const updateChild = useSelector((state: any) => state.materials?.updateChild ?? { loading: false });
  const {screening: {oneTest: oneTestState}}:RootState = useSelector(selectStore);
  const [isButtonChildDisabled, setIsButtonChildDisabled] = useState(true);
  const [formChild] = Form.useForm();
  const {handleChangeLang, lang} = useLang()

  const [error, setError] = useState(null);
  const dateFormat = 'DD/MM/YYYY';
  const [isLoading, setIsLoading] = useState(false);

  const [genders, setGenders] = useState([
      { id: 1, name: t("boy") },
      { id: 2, name: t("girl") },
    ]);

   const [formChildData, setFormChildData] = useState({
      firstName:  '',
      lastName: '',
      dateOfBirth: null,
      gender: null
    });

  const embeddedNavigate = useEmbeddedNavigate();
  const handleGoBack = () => {
    embeddedNavigate(-1)
  }

  // const getYearLabel = (age: number) => {
  //   const lastDigit = age % 10;
  //   const lastTwoDigits = age % 100;
  
  //   if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("ages2");
  //   if (lastDigit === 1) return t("ages1");
  //   if (lastDigit >= 2 && lastDigit <= 4) return t("ages");
  //   return t("ages2");
  // };

  // const questions = oneTestState?.data || [];
  const questions = Array.from({ length: 6 }, (_, index) => ({
    id: index + 1,
  }));

  const currentQuestion = questions[currentQuestionIndex];

  // const fetchChildrensData = async () => {
  //   try {
  //     const response = await fetchGetChildrens();
  //     setChildrens(response?.children);
  //   } catch (error) {
  //     console.error("Ошибка при получении детей", error);
  //   }
  // };

  useEffect(() => {
  dispatch(fetchChildrensAction({}));
}, []);
  
  // useEffect(() => {
  //   fetchChildrensData();
  // }, []);

  const handleChildChange = (childId: number) => {
  const selectedChild = childrens.find((child) => child.id === childId);

  if (selectedChild) {
    setChildName(selectedChild.first_name);
    setChildId(selectedChild.id);

    if (selectedChild.age_in_months) {
      const years = Math.floor(selectedChild.age_in_months / 12);
      setAge(years);
    }
  }
};

const handleChildInputChange = (field: string, value: string | boolean) => {
    setFormChildData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

// const handleAddChildClick = async () => {
//   setIsLoading(true);

//   const payload = {
//     first_name: formChildData.firstName,
//     last_name: formChildData.lastName,
//     birth_date: dayjs(formChildData.dateOfBirth).format("YYYY-MM-DD"),
//     gender: formChildData.gender
//   };

//   try {
//     let response;

//     if (editingChild) {
//       response = await fetchUpdateChild(editingChild.id, payload);
//     } else {
//       response = await fetchAddChild(payload);
//     }

//     if (response?.errors) {
//       setIsButtonChildDisabled(false)
//       setError(response.errors);
//       return;
//     }

//     await dispatch(fetchModules({}));

//     formChild.resetFields();
//     setFormChildData({
//       firstName: "",
//       lastName: "",
//       dateOfBirth: null,
//       gender: null
//     });
//     setEditingChild(null);
//     setError(null);

//     await fetchChildrensData();
//     setShowForm(false)

//     // navigate("/profile");
//   } catch (error) {
//     console.error("Ошибка при отправке заявки", error);
//     if (error?.response?.data?.errors) {
//       setError(error.response.data.errors);
//     }
//   } finally {
//     setIsLoading(false);
//   }
// };

const handleAddChildClick = () => {
  const childData = {
    first_name: formChildData.firstName,
    last_name: formChildData.lastName,
    birth_date: dayjs(formChildData.dateOfBirth).format("YYYY-MM-DD"),
    gender: formChildData.gender,
  };

  if (editingChild) {
    dispatch(fetchUpdateChildAction({ id: editingChild.id, childData }));
  } else {
    dispatch(fetchAddChildAction({ childData }));
  }
};

useEffect(() => {
  if (!addChild.success && !updateChild.success) return;

  formChild.resetFields();
  setFormChildData({ firstName: "", lastName: "", dateOfBirth: null, gender: null });
  setEditingChild(null);
  setError(null);
  setShowForm(false);
}, [addChild.success, updateChild.success]);

useEffect(() => {
  if (!addChild.failed) return;

  setError(addChild.data);
  setIsButtonChildDisabled(false);
}, [addChild.failed, addChild.data]);


useEffect(() => {
  if (!updateChild.failed || !updateChild.data) return;
  setError(updateChild.data);
  setIsButtonChildDisabled(false);
}, [updateChild.failed]);

const isChildLoading = addChild.loading || updateChild.loading;

const handleAddNew = () => {
  formChild.resetFields();
    setFormChildData({
      firstName: "",
      lastName: "",
      dateOfBirth: null,
      gender: null
    });
    
    setEditingChild(null);
    setError(null);
};

useEffect(() => {
  const { firstName, lastName, dateOfBirth, gender } = formChildData;
  
  const isFormComplete =
    firstName &&
    lastName &&
    dateOfBirth &&
    gender

  setIsButtonChildDisabled(!isFormComplete);
}, [formChildData]);

const getYearLabel = (age: any) => { const lastDigit = age % 10; const lastTwoDigits = age % 100; if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("ages2"); if (lastDigit === 1) return t("ages1"); if (lastDigit >= 2 && lastDigit <= 4) return t("ages"); return t("ages2"); };
const getMonthLabel = (age: any) => { const lastDigit = age % 10; const lastTwoDigits = age % 100; if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("months"); if (lastDigit === 1) return t("months2"); if (lastDigit >= 2 && lastDigit <= 4) return t("months1"); return t("months"); };

const formatAge = (ageInMonths: number) => {
  const years = Math.floor(ageInMonths / 12);
  const months = ageInMonths % 12;

  let result = "";

  if (years > 0) {
    result += `${years} ${getYearLabel(years)}`;
  }

  if (months > 0) {
    result += (result ? " " : "") + `${months} ${getMonthLabel(months)}`;
  }

  return result || t("months");
};

  return(
    

    <>
    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 26, height: '60px'}}>
          {screens.xs ? (
                        <>
                          <Col span={3}>
                            <ButtonContainer onClick={handleGoBack}>
                              <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                            </ButtonContainer>
                          </Col>
                          <Col span={21}>
                            <MyText
                              color="rgba(19, 15, 38, 1)"
                              size={26}
                              weight={800}
                              style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                            >
                              {`${t("selfDiagnosis")}`}
                            </MyText>
                          </Col>
                        </>
                      ) : (
                        <>
                          <ButtonContainer onClick={handleGoBack}>
                            <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                          </ButtonContainer>
                          <MyText
                            color="rgba(19, 15, 38, 1)"
                            size={32}
                            weight={800}
                            style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                          >
                            {`${t("selfDiagnosis")}`}
                          </MyText>
                        </>
                      )}
        </Row>
        <Spin spinning={oneTestState?.loading}>
    <Row gutter={16}>
      <Col span={24}>
        <Card style={{ height: "100%", borderRadius: '20px' }} styles={{ body: { height: "100%" } }}>
          {currentQuestion ? (
            <Form style={{ height: "100%" }}>
              <Row>
                <MyText 
                  color="rgba(19, 15, 38, 1)" 
                  weight={800} 
                  size={32} 
                  style={{ fontFamily: 'Nunito', lineHeight: screens.xs ? '36px' : '48px' }}
                >
                  {`${t("chooseChild")}`}
                </MyText>
              </Row>

              <Col span={24}>
                        <Row gutter={[24, 24]} style={{ marginTop: 32 }}>
              
                        {childrens?.length ? (
                            childrens.map((child) => (
                              <Col key={child.id} span={24} style={{border: selectedId === child.id ? "2px solid #1890ff" : "2px solid transparent", padding: 12 , borderRadius: 16, cursor: 'pointer'}}  
                              onClick={() => {
                                setSelectedId(child.id);
                                setShowForm(false);
                              }}>
              
                                <Row justify='space-between' align="middle">
                                <Col span={18}>
                                <Row gutter={[8,8]} align="middle">
                                <Image
                                  // src={child.gender === 1 ? BoyImage : GirlImage}
                                  src={child?.avatar}
                                  preview={false}
                                  width={60}
                                  height={60}
                                  style={{marginRight: 12}}
                                />
                                <Col>
                                <MyText
                                  color="rgba(10, 3, 60, 1)"
                                  size={22}
                                  weight={600}
                                  style={{ fontFamily: "Nunito", display: "block", marginLeft: 4 }}
                                >
                                  {child.first_name}
                                </MyText>
                                <Col>
                                <Row gutter={8}>
                                  <Col>
                                <MyText
                                  color="rgba(10, 3, 60, 1)"
                                  size={14}
                                  weight={600}
                                  style={{ fontFamily: "Nunito", display: "block", marginTop: 6 }}
                                >
                                  {/* {t("dateOfBirth")}:  */}
                                  <CalendarOutlined style={{marginRight: 6}}/>
                                  {dayjs(child.birth_date).format("DD.MM.YYYY")}
                                </MyText>
                                </Col>
                                <Col>
                                <MyText
                                  color="rgba(10, 3, 60, 1)"
                                  size={14}
                                  weight={600}
                                  style={{ fontFamily: "Nunito", display: "block", marginTop: 6 }}
                                >
                                  {/* {t("age")}:  */}
                                  <UserOutlined style={{marginRight: 6}}/>
                                  ({formatAge(child.age_in_months)})
                                </MyText>
                                </Col>
                                <Col>
                                  <MyText
                                    color="rgba(10, 3, 60, 1)"
                                    size={14}
                                    weight={600}
                                    style={{ fontFamily: "Nunito", display: "block", marginTop: 6 }}
                                  >
                                    {Number(child.gender) === 1 ? (
                                      <ManOutlined style={{ marginRight: 6 }} />
                                    ) : (
                                      <WomanOutlined style={{ marginRight: 6 }} />
                                    )}
                                    {Number(child.gender) === 1 ? t("boy") : t("girl")}
                                  </MyText>
                                </Col>
                                </Row>
                                </Col>
                                </Col>
                                </Row>
                              </Col>

                               {selectedId === child.id &&
                                child?.age_in_months &&
                                child.age_in_months >= 12 &&
                               child.age_in_months <= 72 && (
                                  <Col style={{marginTop: screens.xs? 12 : 0}}>
                                    <MyButton
                                      color="orange"
                                      type="primary"
                                      onClick={() => {
                                        const years = Math.floor(child.age_in_months / 12);
                                        embeddedNavigate(
                                          `/screening/tests-list/${testId}/age/${years}/name/${child.first_name}/childId/${child.id}`
                                        );
                                      }}
                                    >
                                      {t("startTest")}
                                    </MyButton>
                                  </Col>
                                )}
              
                                </Row>
              
                              </Col>
                            ))
                          ) : (
                            <Col span={24} style={{ marginTop: 32 }}>
                              <MyText
                                color="rgba(71, 74, 87, 1)"
                                size={22}
                                weight={700}
                                style={{ fontFamily: "Nunito", display: "block" }}
                              >
                                {t("noChildren")}
                              </MyText>
                            </Col>
                          )}
                        </Row>
                        </Col>

              <Form
                form={formChild}
                // onFinish={handleSave}
                onValuesChange={(changedValues, allValues) => {
                  setFormChildData((prev) => ({
                    ...prev,
                    ...allValues,
                  }));
                }}
            >

               <Col span={24}>
                    {!showForm ? (
                      <MyButton
                        color="orange"
                        type="primary"
                        onClick={() => setShowForm(true)}
                        style={{ marginTop: 32 }}
                      >
                        {t("addChild")}
                      </MyButton>
                    ) : (
                        <Row gutter={[24, 0]} style={{ marginTop: 32 }}>
                                  <Col span={screens.xs ? 24 : 6}>
                                    <MyText color="rgba(71, 74, 87, 1)" size={22} weight={700} style={{ fontFamily: "Nunito", display: "block" }}>
                                      {t("lastName")}
                                    </MyText>
                                    <Form.Item
                                      name="lastName"
                                      rules={[{ required: true }]}
                                      help={<span style={{ color: "red" }}>{error?.last_name?.[0]}</span>}
                                    >
                                      <Input
                                        placeholder={t("enterChildSurname")}
                                        onChange={(e) => handleChildInputChange("lastName", e.target.value)}
                                        style={{ marginTop: 6, padding: 12 }}
                                      />
                                    </Form.Item>
                                  </Col>
                        
                                  <Col span={screens.xs ? 24 : 6}>
                                    <MyText color="rgba(71, 74, 87, 1)" size={22} weight={700} style={{ fontFamily: "Nunito", display: "block" }}>
                                      {t("firstName")}
                                    </MyText>
                                    <Form.Item
                                      name="firstName"
                                      rules={[{ required: true }]}
                                      help={<span style={{ color: "red" }}>{error?.first_name?.[0]}</span>}
                                    >
                                      <Input
                                        placeholder={t("childNamePlaceholder")}
                                        onChange={(e) => handleChildInputChange("firstName", e.target.value)}
                                        style={{ marginTop: 6, padding: 12 }}
                                      />
                                    </Form.Item>
                                  </Col>
                        
                                  <Col span={screens.xs ? 24 : 6}>
                                    <MyText color="rgba(71, 74, 87, 1)" size={22} weight={700} style={{ fontFamily: "Nunito", display: "block" }}>
                                      {t("gender")}
                                    </MyText>
                                    <Form.Item
                                      name="gender"
                                      rules={[{ required: true }]}
                                      help={<span style={{ color: "red" }}>{error?.gender?.[0]}</span>}
                                    >
                                      <StyledSelect
                                        placeholder={t("selectGender")}
                                        style={{ width: "100%", marginTop: 6, height: 52 }}
                                      >
                                        {genders.map((gender) => (
                                          <Option key={gender.id} value={gender.id}>
                                            {gender.name}
                                          </Option>
                                        ))}
                                      </StyledSelect>
                                    </Form.Item>
                                  </Col>
                        
                                  <Col span={screens.xs ? 24 : 6}>
                                    <MyText color="rgba(71, 74, 87, 1)" size={22} weight={700} style={{ fontFamily: "Nunito", display: "block" }}>
                                      {t("dateOfBirth")}
                                    </MyText>
                                    <Form.Item
                                      name="dateOfBirth"
                                      rules={[{ required: true }]}
                                      help={<span style={{ color: "red" }}>{error?.birth_date?.[0]}</span>}
                                    >
                                      <DatePicker
                                        style={{ height: 53, width: "100%", marginTop: 6 }}
                                        defaultValue={dayjs("01/01/2019", dateFormat)}
                                        format={dateFormat}
                                        locale={lang === "kk" ? localeKz : localeRu}
                                        placeholder="ДД.ММ.ГГ"
                                      />
                                    </Form.Item>
                                  </Col>
                        
                                  <Col>
                                    <MyButton
                                      color="orange"
                                      type="primary"
                                      disabled={isButtonChildDisabled}
                                      onClick={handleAddChildClick}
                                    >
                                      {editingChild ? t("save") : t("addChild")}
                                    </MyButton>
                                  </Col>
                        
                                  {editingChild && (
                                    <Col>
                                      <MyButton
                                        color="orange"
                                        type="primary"
                                        onClick={handleAddNew}
                                      >
                                        {t("addChild")}
                                      </MyButton>
                                    </Col>
                                  )}
                                </Row>
                    )}
                    </Col>
                    </Form>
              
              {/* <Row gutter={16} style={{ marginTop: 24 }}>
                <Col span={screens.xs ? 24 : 12} style={{marginBottom: screens.xs ? 16 : 0}}>
                  <MyText 
                    color="rgba(76, 76, 77, 1)" 
                    weight={600} 
                    size={18} 
                    style={{ fontFamily: 'Nunito', lineHeight: '24px' }}
                  >
                    {`${t("consultationName")}`}
                  </MyText>

                    <StyledAutoComplete
                      value={childName}
                      onChange={handleChildChange}
                      placeholder={t("childNamePlaceholder")}
                      style={{
                        marginTop: "8px",
                        fontFamily: "Nunito",
                        lineHeight: "24px",
                        fontSize: 16,
                        width: "100%",
                        height: "58px",
                      }}
                      options={[
                        ...childrens
                          .filter((child) => Math.floor(child.age_in_months / 12) <= 6)
                          .map((child) => ({
                            value: child.id,
                            label: child.first_name,
                          })),
                        {
                          value: "add_child",
                          label: (
                            <div
                              style={{
                                color: "#1677ff",
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                              onClick={() => embeddedNavigate("/profile")}
                            >
                              + {t("addChild")}
                            </div>
                          ),
                        },
                      ]}
                    />

                </Col>
                <Col span={screens.xs ? 24 : 12}>
                  <MyText 
                    color="rgba(76, 76, 77, 1)" 
                    weight={600} 
                    size={18} 
                    style={{ fontFamily: 'Nunito', lineHeight: '24px' }}
                  >
                    {`${t("age")}`}
                  </MyText>
                  <StyledSelect
                    value={age}
                    onChange={(value) => setAge(value)}
                    style={{
                      marginTop: '8px',
                      fontFamily: 'Nunito',
                      lineHeight: '24px',
                      fontSize: 16,
                      width: '100%',
                      height: '58px'
                    }}
                    placeholder={t("selectFromList")}
                  >
                    {Array.from({ length: 6 }, (_, index) => {
                      const currentAge = index + 1;
                      return (
                        <Select.Option key={currentAge} value={currentAge} label={`${currentAge} ${getYearLabel(currentAge)}`}>
                          {`${currentAge} ${getYearLabel(currentAge)}`}
                        </Select.Option>
                      );
                    })}
                  </StyledSelect>
                </Col>
              </Row> */}

              {/* <Row justify="center" style={{ marginTop: 32 }}>
                <Col>
                  <MyButton
                    color="orange"
                    type="primary"
                    style={{ padding: '28px 28px' }}
                    disabled={!childName || !age}
                    onClick={() => {
                      embeddedNavigate(`/screening/tests-list/${testId}/age/${age}/name/${childName}/childId/${childId}`);
                    }}
                  >
                    <MyText
                      color={!childName || !age ? "rgba(19, 15, 38, 1)" : "#fff"}
                      weight={600}
                      size={18}
                      style={{ lineHeight: '24px' }}
                    >
                      {`${t("startTest")}`}
                    </MyText>
                    <RightOutlined
                      style={{
                        color: !childName || !age ? "rgba(19, 15, 38, 1)" : "#fff",
                      }}
                    />
                  </MyButton>
                </Col>
              </Row> */}
            </Form>
          ) : (
            <Spin loading={!!currentQuestion} />
          )}
        </Card>
      </Col>
    </Row>
  </Spin>
      </Col>
    </Row>
    </>
  )
}